<template>
    <div class="fixed inset-0 z-50 overflow-auto bg-smoke-light flex items-center justify-center">
        <div class="field bg-white rounded shadow rounded border-red border-t-4 border-solid p-8 animated faster slideInUp">
            <h2 class="text-2xl capitalize">Deleting {{ this.type }}</h2>
            <p class="text-md">Are you sure you want to delete this {{ this.type }}?</p>
            <div class="flex mt-4">
                <a href="" @click.prevent="handleConfirm" class="button is-danger">Yes, Delete</a>
                <a href="" @click.prevent="handleCancel" class="button is-tertiary ml-4">Cancel</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                required: true
            }
        },

        methods: {
            handleConfirm() {
                this.$emit('confirm')
            },
            handleCancel() {
                this.$emit('cancel')
            }
        }
    }
</script>
